import { axiosInstance } from "../services/utilities";
import axios from "axios";
export var api = async function ({ method = "get", url, body, status = false, token = '' }, config = {}) {
    return await new Promise((resolve, reject) => {
        axiosInstance.defaults.headers.common['authorization'] = getToken() ? getToken() : ''
        axiosInstance[method](api, (body ? body : ""), config).then((data) => {
            resolve(statusHelper(status, data))
        }).catch((error) => {
            if (error) {
                if (error.response) {
                    reject(statusHelper(status, error.response))

                } else {
                    reject(error)
                }
            } else {
                reject(false)
            }
        })
    })
};

export const getToken = () => {
    return localStorage.getItem('token');
};

export const makeRequest = async (methodType, url, payload, additionalHeaders = {}, status = false) => {
    const headers = {
        ...additionalHeaders,
        // "Authorization": getToken() ? getToken() : ''
    };

    if (methodType.toLowerCase() === 'get') {
        return await new Promise((resolve, reject) => {
            axios[methodType](url, { headers, crossdomain: true }).then((data) => {
                resolve(statusHelper(status, data))
            }).catch((error) => {
                if (error) {
                    if (error.response) {
                        reject(statusHelper(status, error.response))

                    } else {
                        reject(error)
                    }
                } else {
                    reject(false)
                }
            })
        })
    } else if (methodType.toLowerCase() === 'delete') {
        return await new Promise((resolve, reject) => {
            axios[methodType](url, { headers, crossdomain: true }).then((data) => {
                resolve(statusHelper(status, data))
            }).catch((error) => {
                if (error) {
                    if (error.response) {
                        reject(statusHelper(status, error.response))

                    } else {
                        reject(error)
                    }
                } else {
                    reject(false)
                }
            })
        })
    } else {
        return await new Promise((resolve, reject) => {
            axios[methodType](url, payload, { headers, crossdomain: true }).then((data) => {
                resolve(statusHelper(status, data))
            }).catch((error) => {
                if (error) {
                    if (error.response) {
                        reject(statusHelper(status, error.response))
                    } else {
                        reject(error)
                    }
                } else {
                    reject(false)
                }
            })
        })
    }
}


var statusHelper = (status, data) => {
    if (data.status === 401 && data.statusText !== "Unauthorized") {
        window.location.href = process.env.REACT_APP_FRONTEND_SERVICE_1 + '/refresh-token'
    }

    if (status) {
        return {
            status: data.status,
            response: data.data
        }
    } else {
        return data.data
    }
}